import { Component, OnInit, ViewChild } from '@angular/core'
import { DialogComponent } from '../../dialog/dialog.component'

@Component({
  selector: 'app-generic',
  templateUrl: './generic.component.html',
  styleUrls: ['./generic.component.scss']
})
export class GenericComponent implements OnInit {
  @ViewChild('dialog') dialogRef: DialogComponent

  color = 'primary'
  icon = 'close'
  message = ''

  constructor() { }

  ngOnInit() {}

  show () {
    return this.dialogRef.show()
  }
}
